import React, { useEffect, useRef } from 'react';
import styles from './StanAccordionItem.module.css';
import StanDivider from '../../StanDivider/StanDivider';
import { StanAccordionItemProps } from '../StanAccordion.types';
import { AccordionItemContext, useAccordionContext } from '../StanAccordion.context';
import { cn } from '@/lib';

export const StanAccordionItem: React.FC<StanAccordionItemProps> = ({
    id,
    children,
    className = '',
    isCard = false,
    startOpen = false,
    showDivider = false,
}) => {
    const computedClass = cn(isCard ? styles.card : '', className);
    const { isItemOpen, toggleItem } = useAccordionContext();
    const didSetInitial = useRef(false);

    useEffect(() => {
        if (startOpen && !didSetInitial.current && !isItemOpen(id)) {
            toggleItem(id);
            didSetInitial.current = true;
        }
    }, [id, isItemOpen, startOpen, toggleItem]);

    return (
        <AccordionItemContext.Provider value={{ id }}>
            <div id={id} className={computedClass}>
                <div>{children}</div>
                {showDivider && <StanDivider />}
            </div>
        </AccordionItemContext.Provider>
    );
};
